import React, { useState, useEffect } from "react";
import Stars from "./Stars";
import { useTranslation } from "react-i18next";
import MoreInfo from "../../../lib/MoreInfo";
import bikeTypeSupportsFitting from "../FittingSupport";
import ReactGA from 'react-ga4';
import { useDispatch, useSelector } from "react-redux";
import { goTo, startFromBikefinder } from "../../../redux/actions/bikefit";
import Api from "../../../lib/Api";
import {checkChoices, getResultVars} from "../../Bikefit/lib/bikefit";
import { config } from "../../../config";
import Locale from "../../../lib/Locale";
import {selectBikefitChoices} from "../../../redux/selectors/bikefit";

const SummaryGeo = ({
  traject,
  mtb,
  usage,
  bikeType,
  setMeasureBikefit,
  lastUsedMeasure,
  chosenIntegrationOption,
}) => {
  const [t] = useTranslation("result");
  const dispatch = useDispatch();
  const choices = useSelector(selectBikefitChoices);
  const [qualityScore, setQualityScore] = useState("");

  useEffect(() => {
    if (checkChoices(choices)) {
      const url = "/get_measurements_quality";
      const resultVars = getResultVars(choices);

      Api.get(url, resultVars)
          .then((response) => {
            setQualityScore(response.data.data.quality_score);
          })
          .catch((response) => {
            console.log("error");
          });
    }
  }, []);

  let basedOn = "";

  if (!bikeTypeSupportsFitting(bikeType)) {
    basedOn = t("MTBSummary_CTA_NofitPossible");
  } else if (lastUsedMeasure === "no") {
    basedOn = t("MTBSummary_CTA_Nofit");
  } else if (lastUsedMeasure === "body") {
    basedOn = t("MTBSummary_CTA_Body");
  } else if (lastUsedMeasure === "mtb") {
    basedOn = t("MTBSummary_CTA_Mtb");
  } else if (lastUsedMeasure === "race") {
    basedOn = t("MTBSummary_CTA_Race");
  } else if (lastUsedMeasure === "bikefit") {
    basedOn = t("MTBSummary_CTA_Bikefit");
  }

  let stuurpen_hoek = mtb.geo_fit.cockpit.stem_angle;
  let cockpitImage = "/img/" + traject + "_cockpit_omhoog.png";
  if (stuurpen_hoek < 0) {
    stuurpen_hoek = Math.abs(stuurpen_hoek) + t("MTBSummary_UP");
  } else {
    stuurpen_hoek = stuurpen_hoek + t("MTBSummary_DOWN");
    cockpitImage = "/img/" + traject + "_cockpit_omlaag.png";
  }
  const messages = mtb.geo_fit.messages.map((item, i) => {
    if (item.indexOf("01_") === 0) {
      return <li key={i}>{t("MTBSummary_Seatlength")}</li>;
    }
    if (item.indexOf("02_") === 0) {
      return <li key={i}>{t("MTBSummary_SeatIsLow")}</li>;
    }
    if (item.indexOf("03_") === 0) {
      return <li key={i}>{t("MTBSummary_SeatIsHigh")}</li>;
    }
    if (item.indexOf("04_") === 0) {
      return <li key={i}>{t("MTBSummary_SeatNeedsLongerPing")}</li>;
    }
    if (item.indexOf("05_") === 0) {
      return <li key={i}>{t("MTBSummary_SeatTooCloseBack")}</li>;
    }
    if (item.indexOf("06_") === 0) {
      return <li key={i}>{t("MTBSummary_SeatTooCloseFront")}</li>;
    }
    if (item.indexOf("07_") === 0) {
      return <li key={i}>{t("MTBSummary_SteeringSizingUnknown")}</li>;
    }
    if (item.indexOf("08_") === 0) {
      return <li key={i}>{t("MTBSummary_RequireOtherSteering")}</li>;
    }
    if (item.indexOf("09_") === 0) {
      return <li key={i}>{t("MTBSummary_DropperReachTooSmall")}</li>;
    }
    return "";
  });

  // message for dirtbike & downhill
  const topMessage = () => {
    if (!bikeTypeSupportsFitting(bikeType)) {
      return (
        <div className="message-container">{t("No_Advice_For_Bike_Type")}.</div>
      );
    } else if (lastUsedMeasure === "no") {
      return (
        <div className="message-container">{t("MTBSummary_No_Body")}.</div>
      );
    }
  };

  const bikefitClicked = () => {
    ReactGA.event({
      action: "click",
      category: "bikefit_summary_notice_start",
      label: "Start bikefit from bike summary notice",
      value: 0,
    });
    setMeasureBikefit();
    dispatch(startFromBikefinder(traject, bikeType, true));
    let sittingPosition = "sittingPosition";
    if (traject === "mtb") sittingPosition += "MTB";
    if (traject === "race") sittingPosition += "Road";
    dispatch(goTo("stepB", sittingPosition));
  };

  return (
    <div className="geo-fit">
      <div className="row justify-content-center row-eq-height">
        {topMessage()}
        <div className="col-11 geo-section">
          <h3>{t("MTBSummary_GeoMetricScore")}</h3>
          <div className="row">
            <div className="col-6 col-xl-3 col-sm-4">
              <p>{t("MTBSummary_TotalScore")}</p>
            </div>
            <div className="col-6 col-xl-2 col-sm-2 alignright">
              <p>{mtb.summary.fit}%</p>
            </div>
            <div className="col-12 col-xl-1 col-sm-2"></div>
            <div className="col-12 col-xl-6 col-sm-6">
              {mtb.summary.fit !== null ? (
                <Stars number={Math.round(mtb.summary.fit / 10)} />
              ) : (
                t("Result_NotApplicable")
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-6 col-xl-3 col-sm-4">
              <p>{t("MTBSummary_FitPotentional")}</p>
            </div>
            <div className="col-6 col-xl-2 col-sm-2 alignright">
              <p>{mtb.geo_fit.score_details.score_fit}%</p>
            </div>
            <div className="col-12 col-xl-1 col-sm-2"></div>
            <div className="col-12 col-xl-6 col-sm-6">
              <p></p>
            </div>
          </div>

          <div className="row">
            <div className="col-6 col-xl-3 col-sm-4">
              <p>{t("MTBSummary_AttentionPoints")}</p>
            </div>
            <div className="col-6 col-xl-2 col-sm-2 alignright">
              <p>
                {mtb.geo_fit.score_details.score_data ||
                mtb.geo_fit.score_details.score_part_changes
                  ? mtb.geo_fit.score_details.score_data +
                    mtb.geo_fit.score_details.score_part_changes +
                    "%"
                  : t("Result_NotApplicable")}
              </p>
            </div>
            <div className="col-12 col-xl-1 col-sm-2"></div>
            <div className="col-12 col-xl-6 col-sm-6">
              <ul className="part_changes_ul">{messages}</ul>
            </div>
          </div>
          <p
            className="link moreInfo"
            onClick={() => {
              MoreInfo.show("info", "geofit");
            }}
          >
            {t("MTBSummary_MoreInfo")}
          </p>
        </div>

        <div className="col-11 geo-section">
          <h3>{t("MTBSummary_ConfigurationAdvice")}</h3>
          <div className="row align-items-center">
            <div className="col-sm-6 text-center">
              <img
                src={"/img/silhouette-" + traject + "-results.png"}
                className="img-responsive"
                alt="Mountainbike maten"
              />
            </div>
            <div className="col-xl-4 col-sm-6">
              <div className="row">
                <div className="col-6">{t("MTBSummary_SeatHeight")}:</div>
                <div className="col-6 alignright">
                  {usage !== "Fun in bike parks" &&
                  usage !== "Pure downhill" &&
                  lastUsedMeasure !== "no"
                    ? Math.round(
                        mtb.geo_fit.bike_fit_target.saddle_height / 10,
                        1
                      ) + " cm"
                    : "0"}
                </div>
              </div>
              <div className="row">
                <div className="col-6 col-sm-6">
                  {t("MTBSummary_SeatSetBack")}:
                </div>
                <div className="col-6 alignright">
                  {usage !== "Fun in bike parks" &&
                  usage !== "Pure downhill" &&
                  lastUsedMeasure !== "no"
                    ? Math.round(
                        mtb.geo_fit.bike_fit_target.saddle_setback / 10,
                        1
                      ) + " cm"
                    : "0"}
                </div>
              </div>
              <div className="row">
                <div className="col-6 col-sm-6">
                  {t("MTBSummary_SitLength")}:
                </div>
                <div className="col-6 alignright">
                  {usage !== "Fun in bike parks" &&
                  usage !== "Pure downhill" &&
                  lastUsedMeasure !== "no"
                    ? Math.round(
                        mtb.geo_fit.bike_fit_target.bike_length / 10,
                        1
                      ) + " cm"
                    : "0"}
                </div>
              </div>
              <div className="row">
                <div className="col-6 col-sm-6">{t("MTBSummary_Drop")}:</div>
                <div className="col-6 alignright">
                  {usage !== "Fun in bike parks" &&
                  usage !== "Pure downhill" &&
                  lastUsedMeasure !== "no"
                    ? Math.round(
                        mtb.geo_fit.bike_fit_target.bike_drop / 10,
                        1
                      ) + " cm"
                    : "0"}
                </div>
              </div>
            </div>
          </div>

          <p
            className="link moreInfo"
            onClick={() => {
              MoreInfo.show("info", "personalfit");
            }}
          >
            {t("MTBSummary_MoreInfo")}
          </p>

          <div className="cta-notice">
            <div>{basedOn}</div>
            {lastUsedMeasure === 'bikefit' && (
              <p className="d-flex mt-2">
                {t("BASIS_FOR_ADVICE", {
                  qualityScore:
                    qualityScore && t("QUALITY_MEASUREMENTS_" + qualityScore),
                })}{"  "}
                <a
                  className="ml-2 btn-link"
                  href={Locale.getUrlForCurrentLocale(`${config.bikefitUrl}/bikefit/measurments-quality?isPaid=false`)}
                >
                  {t("LINK")}
                </a>
              </p>
            )}
            {lastUsedMeasure !== "bikefit" && bikeTypeSupportsFitting(bikeType) && (
              <button
                className="btn btn-secondary"
                style={{ float: "right", width: "202px" }}
                onClick={bikefitClicked}
              >
                {t("Start bikefit")}
              </button>
            )}
          </div>
        </div>

        <div className="col-11 geo-section">
          <h3>{t("MTBSummary_AdvicesCockpitSizes")}</h3>
          {mtb.bike_model.bike_type.indexOf("Aero") !== -1 ? (
            <div className="message-container">{t("MTBSummary_Beware")}</div>
          ) : (
            ""
          )}
          <div className="row align-items-center">
            <div className="col-sm-6 text-center">
              <img
                className="img-responsive cockpit"
                src={cockpitImage}
                alt="stuur afstelling"
              />
            </div>
            <div className="col-sm-6 col-xl-4">
              <div className="row pnomargin">
                <div className="col-6">
                  <p>{t("MTBSummary_SteeringPinLength")}:</p>
                </div>
                <div className="col-6 alignright">
                  <p>{mtb.geo_fit.cockpit.stem_length} mm</p>
                </div>
              </div>
              <div className="row pnomargin">
                <div className="col-6">
                  <p>{t("MTBSummary_SteeringAngle")}:</p>
                </div>
                <div className="col-6 alignright">
                  <p>{stuurpen_hoek}</p>
                </div>
              </div>
              <div className="row pnomargin">
                <div className="col-6">
                  <p>{t("MTBSummary_Spacers")}:</p>
                </div>
                <div className="col-6 alignright">
                  <p>
                    {mtb.geo_fit.cockpit.spacers} {t("MTBSummary_Millimeter")}
                  </p>
                </div>
              </div>
              {traject === "mtb" && (
                <div className="row pnomargin">
                  <div className="col-6">
                    <p>{t("MTBSummary_SteeringRise")}:</p>
                  </div>
                  <div className="col-6 alignright">
                    <p>
                      {mtb.geo_fit.cockpit.bar_rise}{" "}
                      {t("MTBSummary_Millimeter")}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
          <p
            className="link moreInfo"
            onClick={() => {
              MoreInfo.show("info", "framefitTune");
            }}
          >
            {t("MTBSummary_MoreInfo")}
          </p>
        </div>
      </div>
    </div> // end of return
  );
};

export default SummaryGeo;
